/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'loading-burger': {
    width: 11,
    height: 14,
    viewBox: '0 0 11 14',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd" stroke-linecap="round"><g transform="translate(-11 -9)" _stroke="#FFF"><g class="loading-burger" transform="translate(11 9)"><path pid="0" d="M.5 1h10" class="loading-burger__line loading-burger__line--1"/><path pid="1" d="M.5 5h10" class="loading-burger__line loading-burger__line--2"/><path pid="2" d="M.5 9h10" class="loading-burger__line loading-burger__line--3"/><path pid="3" d="M.5 13h10" class="loading-burger__line loading-burger__line--4"/></g></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/loading-burger.js